import { AxiosInstance } from "axios";
import { Country } from "../models/places";

const PLACES_API_PREFIX = "/places";

export async function getCountries(http: AxiosInstance): Promise<Country[]> {
	const response = await http.get<Country[]>(PLACES_API_PREFIX + "/countries");
	return response.data;
}

export async function getStatesByCountryId(
	http: AxiosInstance,
	countryId: number
): Promise<Country[]> {
	const response = await http.get<Country[]>(
		PLACES_API_PREFIX + `/states/${countryId}`
	);
	return response.data;
}
